import React, { useEffect } from 'react';
import './Hero.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import heroTeamImage from '../../images/hero-team.jpg'
import Button from '../Button/Button';
import Tag from '../Tag/Tag';

const Hero = () => {
  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out',
    });
  }, []);

  return (
    <div className="HERO">
      <div className="Hero">
        <div className="Hero-content">
          <div className="Hero-left">
            <Tag title="Digital Marketing" variant="primary" />
            <h1 className="Hero-title header-1" data-aos="fade-up" data-aos-delay="100">
              Want to Turn Clicks into Clients and Content into Real Cashflow?
            </h1>
            <p className="Hero-description" data-aos="fade-up" data-aos-delay="200">
              We don't just manage your social media—we engineer your digital breakthrough. Whether you're a small business, creator, or company looking to scale, we help you build a brand that SELLS and STICKS.
            </p>
            <div className="Hero-buttons" data-aos="fade-up" data-aos-delay="300">
              <Button variant="primary" text="Read More" url="/about" />
              <Button variant="tertiary" text="Contact us" url="/contact" />
            </div>
          </div>
          <div className="Hero-right">
            <div className="Hero-image-container" data-aos="zoom-in" data-aos-delay="400">
              <img src={heroTeamImage} alt="Team working together" className="Hero-image" />
            </div>
            <div className="Hero-stats" data-aos="fade-up" data-aos-delay="500">
              <div className="Hero-stats-number header-1">100+</div>
              <div className="Hero-stats-title">Happy client</div>
              <div className="Hero-stats-description text-1">
                They are pleased with the quality and value of service.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;